import { z } from 'zod';

const preorderReservationSchema = z.object({
    paymentTypeEnum: z.literal('PREORDER_RESERVATION'),
    title: z.string().optional(),
    body: z.string().optional(),
    /** The amount of the preorder reservation payment */
    amount: z.coerce.number().positive(),
});
// This can be thought of as an alternative to the PREORDER_RESERVATION payment type
// to be used when we need to support different payment amounts in a preorder flow
const preorderVipReservationSchema = z.object({
    paymentTypeEnum: z.literal('PREORDER_VIP_RESERVATION'),
    title: z.string(),
    body: z.string(),
    /** The amount of the preorder VIP reservation payment */
    amount: z.coerce.number().positive(),
});
const preorderPaymentConfigSchema = z.object({
    PREORDER_RESERVATION: preorderReservationSchema,
    PREORDER_VIP_RESERVATION: preorderVipReservationSchema.optional(),
});

export { preorderPaymentConfigSchema };
//# sourceMappingURL=PreorderPaymentConfig.js.map
